module.exports = __webpack_public_path__ + "media/images/icon_list/volume_off-286f97169ebc914c28369325a3a71896.svg";